const capitalize = text => text.charAt(0).toUpperCase() + text.slice(1);

// Returns name with added sequence number, eg `name(2)`, or just `name` if
// `name` nor `name(1)` are not included in names
const getNextNameWithSequenceNumber = (name, names) => {
  if (names.indexOf(name) < 0) {
    return name;
  }

  const nameWithoutSequenceNumber = name.replace(/\(\d\)$/, '');

  const sequenceNumberPattern = new RegExp('^' + nameWithoutSequenceNumber + '\\((\\d)\\)$', 'i');

  const sequenceNumbers = names
    .filter(name => {
      return name.match(sequenceNumberPattern);
    })
    .map(name => {
      const [,num] = name.match(sequenceNumberPattern);
      return parseInt(num, 10);
    });

  const hightestSequencenumber = Math.max(...sequenceNumbers, 0);

  return `${nameWithoutSequenceNumber}(${hightestSequencenumber + 1})`;
};

const stripWhiteSpaces = text => {
  return text.replace(/\s/g,'');
};

export { capitalize, getNextNameWithSequenceNumber, stripWhiteSpaces };



// WEBPACK FOOTER //
// ./client/src/libs/text.js